import Spinner from 'components/Spinner'
import React from 'react'

type InfiniteScrollTriggerProps = {
  triggerRef: React.RefObject<HTMLDivElement>
  isLoading: boolean
  hasMore: boolean | undefined
  loadMoreText?: string
  noMoreText?: string
  className?: string
  showLoadingSpinner?: boolean
}

const InfiniteScrollTrigger = ({
  triggerRef,
  isLoading,
  hasMore,
  loadMoreText = 'Loading more...',
  noMoreText = 'No more items to load',
  className = '',
  showLoadingSpinner = true,
}: InfiniteScrollTriggerProps) => {
  if (!hasMore && !isLoading) {
    return (
      <div className={`text-center py-m text-grey-50 ${className}`}>
        {noMoreText}
      </div>
    )
  }

  return (
    <div
      ref={triggerRef}
      className={`text-center py-m ${className}`}
      data-testid="infinite-scroll-trigger"
    >
      {isLoading && (
        <div className="d-flex align-items-center justify-content-center">
          {showLoadingSpinner && <Spinner size="small" className="mr-s" />}
          <span className="text-grey-70">{loadMoreText}</span>
        </div>
      )}
    </div>
  )
}

export default InfiniteScrollTrigger
